export default {
    exec: (value) => (typeof value === 'object' ? Object.keys(value).length === 0 : !value),
    message: 'required',
};
